import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';
import type { LabelSize, LabelTheme } from './types';

export const Container = styled.div<{
  labelTheme?: LabelTheme;
  bgColor?: string;
  textColor?: string;
  size?: LabelSize;
  clickable?: string;
}>`
  display: inline-block;
  white-space: pre;
  padding: 4px 8px;
  font-size: 14px;
  font-weight: 700;
  border-radius: 4px;
  cursor: ${(props) => (props.clickable === 'true' ? 'pointer' : 'unset')};

  background-color: ${(props) => {
    if (!props.labelTheme) {
      return props.theme.color.blue.default;
    }
    if (props.labelTheme === 'lightBlue') {
      return props.theme.color.blue.lightBlue;
    }
    return props.theme.color[props.labelTheme].default;
  }};

  background-color: ${(props) => props.bgColor && props.bgColor};

  color: ${(props) =>
    props.labelTheme !== 'light' && props.labelTheme !== 'lightBlue'
      ? props.theme.color.light.default
      : props.theme.color.blue.default};

  color: ${(props) => props.textColor && props.textColor};

  ${(props) => props.size === 'small' && 'font-size: 13px; font-weight: 600'};

  ${mediaQuery('small')} {
    font-size: 12px;
  }
`;
